import { ToastContext } from "../../../../hooks/context";
import { checkoutwithCard } from "../../../../services/sales-point";
import { cleanObject } from "../../../../helpers";
import { useSelector } from "react-redux";
import { useContext } from "react";
import { useMutation } from "react-query";

const usePaymentCardModal = ({
  selectBank,
  closePaymentSession,
  closeModal,
}) => {
  const queryParams = new URLSearchParams(window.location.search);
  const orderId = queryParams.get("order_id");
  const triggerToast = useContext(ToastContext);
  const { raven } = useSelector((state) => state.paymentsReducer);

  const { isLoading: loadingExternal, mutate: paidExternally } = useMutation(
    (data) => checkoutwithCard(data),
  );

  const payViaExternal = () => {
    paidExternally(
      cleanObject({
        order_id: orderId,
        payment_provider: raven?.paymentType || null,
        payment_reference: raven?.rrn || null,
        ledger_account_id: selectBank,
      }),
      {
        onSuccess: () => {
          closeModal();
          triggerToast("Payment linked successful", "success");
          closePaymentSession();
        },
      },
    );
  };

  return {
    payViaExternal,
    loadingExternal,
  };
};

export default usePaymentCardModal;
